import { Icon, IconButton } from '@mui/material'
import React from 'react'
import MatxTooltip from '../MatxTooltip/MatxTooltip'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  customHoverFocus: {
    fontSize: '8px',
    '&:hover, &.Mui-focusVisible': { color: theme.palette.primary.main },
  },
}))

type Props = {
  iconName: string
  tooltip: string
  color?: string
  disabled?: boolean
  iconSize?: string
  onClick?: () => void
}

const IconButtonWithTooltip = (props: Props) => {
  const { iconName, tooltip, color, disabled, iconSize, onClick } = props
  const classes = useStyles()
  return (
    <MatxTooltip title={tooltip}>
      <span>
        <IconButton
          size="small"
          disabled={disabled}
          onClick={onClick}
          className={classes.customHoverFocus}
        >
          <Icon style={{fontSize: iconSize, color}}>{iconName}</Icon>
        </IconButton>
      </span>
    </MatxTooltip>
  )
}

export default IconButtonWithTooltip
